import axios from 'axios';
import React from 'react'
import { toast } from 'react-toastify';
import BaseUrl from '../../base-api';

const AxiosInstance = axios.create({
  baseURL: BaseUrl, 
  headers: {
    'Content-Type': 'application/json',
  },
});

AxiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("userToken");
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

AxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const data = error.response?.data;

    if (status === 401 && typeof data === 'string' && data.toLowerCase().includes('expired')) {

      toast.error('Session expired. Redirecting to login...', {
        position: 'top-center',
        autoClose: 3500, 
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
      });

      setTimeout(() => {
        sessionStorage.removeItem("userToken");
        window.location.href = "/login";
      }, 2500);
    }

    return Promise.reject(error);
  }
);




export default AxiosInstance